import { render, staticRenderFns } from "./AwardBadgeDialog.vue?vue&type=template&id=92b8f5c0&scoped=true"
import script from "./AwardBadgeDialog.vue?vue&type=script&lang=js"
export * from "./AwardBadgeDialog.vue?vue&type=script&lang=js"
import style0 from "./AwardBadgeDialog.vue?vue&type=style&index=0&id=92b8f5c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92b8f5c0",
  null
  
)

export default component.exports